import TreeResearcher from "./TreeResearcher";

/**
 * Module for applying researches to text, represented as a tree structure.
 *
 * @see module:parsedPaper/structure
 *
 * @module parsedPaper/research
 */

export {
	TreeResearcher,
};
